<template>
  <div class="gx-purch">
    <gx-loading :show="loading" />
<!--    <h1 class="gx-main__title">采购管理</h1>-->

    <!-- 工具区 -->
    <div class="gx-purch__head">
      <div class="gx-purch__head-row">
          <div class="gx-purch__head-opts">
            <button class="gx-purch__btn gx-purch__btn--del" :disabled="!selectedIds.length" @click="batchDelete">删除</button>
            <button class="gx-purch__btn gx-purch__btn--add" @click="openEdit(null)">+ 新增</button>
          </div>
          <div style="flex: 1;min-width: 0"></div>
          <div class="gx-as__filter custom-form-wrap">
           <el-form inline size="mini">
             <el-form-item label="筛选账号授权状态：">
                <el-select class="w290" v-model="query.auth_status" placeholder="全部" clearable @change="setAuthStatus">
                    <el-option label="全部" value="" />
                    <el-option label="正常" value="normal" />
                    <el-option label="失效" value="invalid" />
                  </el-select>
              </el-form-item>
              <el-form-item label="采购账号：">
                <el-input size="mini" v-model="query.keyword" placeholder="搜索账号或名称" @keyup.enter="getList(true)" style="width: 180px"></el-input>
              </el-form-item>
           </el-form>
        </div>
          <!-- <span class="gx-purch__filter-label">筛选账号授权状态：</span>
          <span class="gx-purch__tab" :class="{ 'gx-purch__tab--on': query.auth_status === '' }" @click="setAuthStatus('')">
            <span class="gx-purch__tab-check">全部</span>
          </span>
          <span class="gx-purch__tab" :class="{ 'gx-purch__tab--normal': query.auth_status === 'normal' }" @click="setAuthStatus('normal')">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2.5 6l2.5 2.5 4.5-4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
            正常
          </span>
          <span class="gx-purch__tab" :class="{ 'gx-purch__tab--invalid': query.auth_status === 'invalid' }" @click="setAuthStatus('invalid')">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M3 3l6 6M9 3l-6 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" /></svg>
            失效
          </span>
          <span class="gx-purch__filter-label">采购账号：</span>
          <el-input size="mini" v-model="query.keyword" placeholder="搜索账号或名称" @keyup.enter="getList(true)" style="width: 180px"></el-input> -->
          <el-button size="mini" class="gx-purch__btn gx-purch__btn--mini gx-purch__btn--query" @click="getList(true)">查询</el-button>
          <button class="gx-purch__btn gx-purch__btn--mini gx-purch__btn--reset" @click="reset">重置</button>
      </div>
      <!-- <div class="gx-purch__head-opts">
        <button class="gx-purch__btn gx-purch__btn--del" :disabled="!selectedIds.length" @click="batchDelete">删除</button>
        <button class="gx-purch__btn gx-purch__btn--add" @click="openEdit(null)">+ 新增</button>
      </div> -->
    </div>
    <div class="gx-purch__table-page">
      <!-- 表格 -->
      <div class="gx-purch__table">
        <table>
          <thead>
            <tr>
              <th style="width: 90px">
                <label class="gx-purch__checkall">
                  <input type="checkbox" :checked="isSelectedAll" @change="toggleSelectAll" />
                  <span class="gx-purch__checkall-box">
                    <svg v-if="isSelectedAll" width="8" height="8" viewBox="0 0 8 8" fill="none"><path d="M1 4l2 2 4-4" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
                  </span>
                </label>
              </th>
              <th style="width: 100px">所属平台</th>
              <th>采购账号</th>
              <th>利润差</th>
              <th>名称</th>
              <th>分组</th>
              <th>授权信息</th>
              <th style="width:120px">授权状态</th>
              <th >操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in list" :key="item.id">
              <td>
                <label class="gx-purch__check">
                  <input type="checkbox" :checked="item.checked" @change="toggleOne(item)" />
                  <span class="gx-purch__check-box">
                    <svg v-if="item.checked" width="8" height="8" viewBox="0 0 8 8" fill="none"><path d="M1 4l2 2 4-4" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
                  </span>
                </label>
              </td>
              <td>
                <span class="gx-purch__plat" :class="item.type == 1 ? 'gx-purch__plat--pdd' : 'gx-purch__plat--tb'">{{ item.type == 1 ? '多多' : '巴巴' }}</span>
              </td>
              <td>
                <span class="gx-purch__account-link">{{ item.phone }}</span>
              </td>
              <td>
                <div class="gx-purch__profit">
                  <span class="gx-purch__profit-num">¥{{ item.profit_margin }}</span>
                  <span class="gx-purch__profit-tip">低于此值不采购</span>
                </div>
              </td>
              <td>
                <div class="gx-purch__name-wrap">
                  <span class="gx-purch__name-text">{{ item.name || '--' }}</span>
                  <span v-if="item.is_default == 1" class="gx-purch__default">默认</span>
                </div>
              </td>
              <td>默认</td>
              <td>
                <div v-if="item.type == 2" class="gx-purch__auth">
                  <template v-if="item.alibaba_account_id > 0 && item.alibaba_account">
                    <p class="gx-purch__auth-line">账号：<span class="gx-purch__auth-line-con">{{ item.alibaba_account.name }}</span></p>
                    <p class="gx-purch__auth-line">有效期：<span  class="gx-purch__auth-line-con">{{ item.alibaba_account.refresh_token_due_text }}</span></p>
                    <p class="gx-purch__auth-pay gx-purch__auth-pay--err" @click="handlerOpenPay(item)" v-if="item.is_without_code_pay != 1"><span class="gx-purch__auth-pay-dot"></span>开通免密支付</p>
                    <p class="gx-purch__auth-pay" v-else><span class="gx-purch__auth-pay-dot"></span>已开通免密支付</p>
                  </template>
                </div>
              </td>
              <td>
                <span class="gx-purch__stat" :class="item.auth_status && item.auth_status.val == 1 ? 'gx-purch__stat--ok' : 'gx-purch__stat--err'">
                  <span class="gx-purch__stat-dot"></span>
                  {{ item.auth_status ? item.auth_status.text : '失效' }}
                </span>
              </td>
              <td>
                <div class="gx-purch__ops">
                  <button v-if="item.type == 2" class="gx-purch__op-btn gx-purch__op-btn--blue" @click="toAuth(item)">巴巴授权</button>
                  <button v-else class="gx-purch__op-btn gx-purch__op-btn--blue" @click="toAuth(item)">多多授权</button>
                  <button v-if="item.is_default == 0" class="gx-purch__op-btn gx-purch__op-btn--orange" @click="setDefault(item)">设为默认</button>
                  <button class="gx-purch__op-btn gx-purch__op-btn--gray" @click="syncOrder(item)">更新采购订单</button>
                  <button class="gx-purch__op-btn gx-purch__op-btn--blue" @click="openEdit(item)">修改</button>
                  <button class="gx-purch__op-btn gx-purch__op-btn--red" @click="del(item)">删除</button>
                </div>
              </td>
            </tr>
            <tr v-if="!list.length">
              <td :colspan="9" class="gx-purch__empty">暂无采购账号，点击"新增"添加</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- 分页 -->
      <!-- <div class="gx-purch__pager">
        <div class="gx-purch__pager-left">
          <span class="gx-purch__pager-total">共 {{ pagination.total }} 条</span>
          <page-size-select :value="pagination.size" :options="[10, 20, 50, 100]" @change="onPageSizeChange" />
        </div>
        <div class="gx-purch__pager-btns">
          <button class="gx-purch__page" :disabled="pagination.page <= 1" @click="getList(pagination.page - 1)"><svg width="10" height="10" viewBox="0 0 10 10"><path d="M6 2L3 5l3 3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg></button>
          <button v-for="n in pageNums" :key="n" class="gx-purch__page" :class="{ 'gx-purch__page--on': n === pagination.page }" @click="getList(n)">{{ n }}</button>
          <button class="gx-purch__page" :disabled="pagination.page >= totalPages" @click="getList(pagination.page + 1)"><svg width="10" height="10" viewBox="0 0 10 10"><path d="M4 2l3 3-3 3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg></button>
        </div>
      </div> -->
      <div style="padding: 10px 14px;background: rgb(245, 240, 232);">
        <Pagination :total="pagination.total" :page.sync="pagination.page" :limit.sync="pagination.size" :page-sizes="[10, 20, 50, 100,  200, 300, 400]" @pagination="getList(pagination.page)"  layout="total, sizes, prev, pager, next, jumper" />
      </div>
    </div>
    <!-- 新增/编辑账号弹窗 -->
    <div v-if="editShow" class="gx-modal" @click.self="editShow = false">
      <div class="gx-modal-box gx-modal-box--lg">
        <div class="gx-modal-head">
          <div class="gx-modal-title-wrap">
            <span class="gx-modal-title">{{ form.id ? `修改采购 - ${form.name}` : '新增采购' }}</span>
          </div>
          <button class="gx-modal-close" aria-label="关闭" @click="editShow = false">
            <svg width="11" height="11" viewBox="0 0 11 11" fill="none" aria-hidden="true">
              <path d="M1 1l9 9M10 1L1 10" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" />
            </svg>
          </button>
        </div>
        <div class="gx-modal-body custom-el-wrapper">
          <div class="gx-purch__field">
            <label class="gx-purch__label"><span class="gx-purch__req">*</span>所属平台</label>
            <div class="gx-purch__radio-row">
              <!-- <label class="gx-purch__radio" :class="{ 'gx-purch__radio--on': form.type == 1 }">
                <input type="radio" :value="1" v-model="form.type" @change="onTypeChange(1)" />
                <span class="gx-purch__radio-dot"></span><span>多多账号</span>
              </label> -->
              <label class="gx-purch__radio" :class="{ 'gx-purch__radio--on': form.type == 2 }">
                <input type="radio" :value="2" v-model="form.type" @change="onTypeChange(2)" />
                <span class="gx-purch__radio-dot"></span><span>巴巴账号</span>
              </label>
            </div>
          </div>

          <div class="gx-purch__field">
            <label class="gx-purch__label">店铺分组</label>
<!--            <multi-select v-model="form.group_ids" :options="filterGroupList" placeholder="请选择分组" />-->
            <el-select v-model="form.group_ids" multiple clearable size="small" style="width: 100%">
              <el-option v-for="item in filterGroupList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>

          <div class="gx-purch__field">
            <label class="gx-purch__label"><span class="gx-purch__req">*</span>手机号</label>
            <input v-model="form.phone" class="gx-purch__input" placeholder="请输入手机号" maxlength="11" />
            <p class="gx-purch__field-note">用于{{form.type == 1?'拼多多':'阿里巴巴'}}账号登录及授权验证</p>
          </div>

          <div class="gx-purch__field">
            <label class="gx-purch__label">名称</label>
            <input v-model="form.name" class="gx-purch__input" placeholder="请输入名称" />
          </div>

          <div v-if="form.type == 1" class="gx-purch__field">
            <label class="gx-purch__label">支付宝账号</label>
            <input v-model="form.alipay_account" class="gx-purch__input" placeholder="请输入支付宝账号" />
          </div>

          <div v-if="form.type == 1" class="gx-purch__field">
            <label class="gx-purch__label">支付宝密码</label>
            <input v-model="form.alipay_password" class="gx-purch__input" placeholder="请输入支付宝密码" />
          </div>

          <div class="gx-purch__field">
            <label class="gx-purch__label">利润差<span class="gx-purch__label-hint">— 利润低于此值时不采购</span></label>
            <div class="gx-purch__delay-row">
              <el-input-number v-model="form.profit_margin" :precision="2" :step="0.1" size="small"></el-input-number>
              <p class="gx-purch__field-tip">利润低于<span>{{form.profit_margin}}</span>元不采购</p>
            </div>
          </div>
          <template v-if="form.type == 2">
            <div class="gx-purch__field">
              <label class="gx-purch__label"><span class="gx-purch__req">*</span>自动采购</label>
              <div class="gx-purch__radio-row">
                <label class="gx-purch__radio" :class="{ 'gx-purch__radio--on': form.alibaba_auto_purchase == 0 }">
                  <input type="radio" :value="0" v-model="form.alibaba_auto_purchase" />
                  <span class="gx-purch__radio-dot"></span><span>关闭</span>
                </label>
                <label class="gx-purch__radio" :class="{ 'gx-purch__radio--on': form.alibaba_auto_purchase == 1 }">
                  <input type="radio" :value="1" v-model="form.alibaba_auto_purchase" />
                  <span class="gx-purch__radio-dot"></span><span>开启</span>
                </label>
              </div>
            </div>
            <div class="gx-purch__field">
              <label class="gx-purch__label">延迟采购时间<span class="gx-purch__label-hint">— 开启自动采购后，延迟指定秒数再下单</span></label>
              <div class="gx-purch__delay-row">
                <!--             <input v-model.number="form.alibaba_auto_purchase_delay" type="number" min="0" class="gx-purch__input gx-purch__input&#45;&#45;sm" placeholder="请输入" />-->
                <el-input-number v-model="form.alibaba_auto_purchase_delay" :min="0" :precision="0" :step="1" size="small"></el-input-number>
                <span class="gx-purch__unit">秒</span>
                <div class="gx-purch__field-tip--tag">需先开启自动采购</div>
              </div>
            </div>
            <div class="gx-purch__field">
              <label class="gx-purch__label">运费风控</label>
              <div class="shipping-risk-row">
                <el-checkbox v-model="form.shipping_risk_fee_enable" :true-label="1" :false-label="0" >当代发费 ≥</el-checkbox>
                <el-input-number v-model="form.shipping_risk_fee_amount" size="mini" :min="0" :precision="2" :controls="false" placeholder="N" ></el-input-number>
                <span class="shipping-risk-text">元时，仅下单不付款</span>
              </div>
              <div class="shipping-risk-row">
                <el-checkbox v-model="form.shipping_risk_ratio_enable" :true-label="1" :false-label="0" >当代发费 ÷</el-checkbox>
                <el-select v-model="form.shipping_risk_ratio_base" size="mini" placeholder="请选择" style="width: 140px;" >
                  <el-option label="抖店子订单金额" value="dd_order"></el-option>
                  <el-option label="采购商品金额" value="purchase_goods"></el-option>
                </el-select>
                <span class="shipping-risk-text">≥</span>
                <el-input-number v-model="form.shipping_risk_ratio_percent"  size="mini"  :min="0" :precision="2" :controls="false" placeholder="n" ></el-input-number>
                <span class="shipping-risk-text">% 时，仅下单不付款</span>
              </div>
            </div>
          </template>
        </div>
        <div class="gx-modal-foot">
          <button class="gx-modal-foot-btn" @click="editShow = false">取消</button>
          <button class="gx-modal-foot-btn gx-modal-foot-btn--yellow" :disabled="saving" @click="save">
            {{ saving ? '保存中...' : '确定' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import GxLoading from '../../components/newUi/GxLoading.vue'
import PageSizeSelect from '../../components/newUi/PageSizeSelect.vue'
import MultiSelect from '../cloudOptimize/MultiSelect.vue'
import gxLoading from '../../mixins/gxLoading'
import Pagination from '../../components/newUi/Pagination.vue'

export default {
  name: 'NewPurchasePage',
  components: { GxLoading, PageSizeSelect, MultiSelect, Pagination },
  mixins: [gxLoading],
  data() {
    return {
      query: { keyword: '', auth_status: '' },
      list: [],
      groupList: [],
      allocatedGroupIds: [],
      pagination: { page: 1, size: 20, total: 0 },
      editShow: false,
      form: {},
      saving: false,

    }
  },
  computed: {
    totalPages() {
      return Math.max(1, Math.ceil(this.pagination.total / this.pagination.size))
    },
    pageNums() {
      const total = this.totalPages
      const nums = []
      const start = Math.max(1, Math.min(this.pagination.page - 2, total - 4))
      for (let i = start; i <= Math.min(total, start + 4); i++) nums.push(i)
      return nums.length ? nums : [1]
    },
    selectedIds() {
      return this.list.filter((item) => item.checked).map((item) => item.id)
    },
    isSelectedAll() {
      return this.list.length > 0 && this.selectedIds.length === this.list.length
    },
    filterGroupList() {
      const detailIds = (this.form.group_ids || []).map((id) => Number(id))
      const allocatedIds = (this.allocatedGroupIds || []).map((id) => Number(id))
      return this.groupList.filter((g) => {
        if (detailIds.includes(Number(g.id))) return true
        if (allocatedIds.includes(Number(g.id))) return false
        return true
      })
    }
  },
  created() {
    this.getList(true)
    this.getGroupList()
  },
  methods: {
    ...mapActions({
      opPddAccountList: 'ucenter_order/opPddAccountList',
      opPddAccountAdd: 'ucenter_order/opPddAccountAdd',
      opPddAccountUpdate: 'ucenter_order/opPddAccountUpdate',
      opPddAccountDel: 'ucenter_order/opPddAccountDel',
      opPddAccountDefault: 'ucenter_order/opPddAccountDefault',
      opPddAccountSyncOrder: 'ucenter_order/opPddAccountSyncOrder',
      getShopBoardGroupList: 'shop_board/getShopBoardGroupList'
    }),
    getList(reset) {
      if (reset === true) this.pagination.page = 1
      this.loadingStart()
      this.opPddAccountList({
        data: {
          page: this.pagination.page,
          limit: this.pagination.size,
          keyword: this.query.keyword,
          group_ids: [],
          auth_status: this.query.auth_status
        },
        success: (res) => {
          this.loadingEnd()
          if (res.code === 200) {
            this.list = (res.data.data || []).map((item) => {
              item.groupids_bak = []
              if (typeof item.group_ids === 'string') {
                item.groupids_bak = item.group_ids ? item.group_ids.split(',').map(Number).filter(Boolean) : []
                item.group_ids = item.groupids_bak.filter(id =>this.groupList.some(g => g.id === id))
              }
              return Object.assign(item, { checked: false })
            })
            this.pagination.page = res.data.current_page || this.pagination.page
            this.pagination.total = res.data.total || 0
            this.allocatedGroupIds = res.data.group_ids || []
          } else {
            this.$message.error(res.msg || res.message)
          }
        }
      })
    },
    getGroupList() {
      this.getShopBoardGroupList({
        data: {},
        success: (res) => {
          if (res.code === 200) this.groupList = res.data || []
        }
      })
    },
    reset() {
      this.query = { keyword: '', auth_status: '' }
      this.getList(true)
    },
    setAuthStatus(val) {
      this.query.auth_status = val
      this.getList(true)
    },
    groupName(id) {
      const g = this.groupList.find((x) => x.id == id)
      return g ? g.name : '未知分组'
    },
    toggleOne(item) {
      item.checked = !item.checked
    },
    toggleSelectAll(e) {
      const val = e.target.checked
      this.list.forEach((item) => { item.checked = val })
    },
    onPageSizeChange(size) {
      this.pagination.size = size
      this.getList(true)
    },
    openEdit(row) {
      this.editShow = true
      if (row && row.id) {
        this.form = Object.assign({}, row, {
          group_ids: Array.isArray(row.group_ids) ? row.group_ids.map(Number) :[]
        })
      } else {
        this.form = { type: 2, phone: null, name: null, group_ids: [], alibaba_auto_purchase: null, alibaba_auto_purchase_delay: 0, alipay_account: null, alipay_password: null, profit_margin: null ,shipping_risk_fee_enable: 0,
          shipping_risk_fee_amount: 0,
          shipping_risk_ratio_enable: 0,
          shipping_risk_ratio_base: 'dd_order',
          shipping_risk_ratio_percent: 0,}
      }
      this.form.shipping_risk_fee_enable = Number(this.form.shipping_risk_fee_enable) ? 1 : 0;
      this.form.shipping_risk_ratio_enable = Number(this.form.shipping_risk_ratio_enable) ? 1 : 0;
      if (!this.form.shipping_risk_ratio_base) {
        this.form.shipping_risk_ratio_base = 'dd_order';
      }
    },
    onTypeChange(val) {
      if (val === 1) {
        this.form.profit_margin = 0.5
      } else {
        this.form.profit_margin = 0.3
        if (this.form.alibaba_auto_purchase == null) this.form.alibaba_auto_purchase = 0
        if (this.form.alibaba_auto_purchase_delay == null) this.form.alibaba_auto_purchase_delay = 0
        if(this.detail.shipping_risk_fee_enable == null) this.detail.shipping_risk_fee_enable = 0
        if(this.detail.shipping_risk_fee_amount == null) this.detail.shipping_risk_fee_amount = 0
        if(this.detail.shipping_risk_ratio_enable == null) this.detail.shipping_risk_ratio_enable = 0
        if(!this.detail.shipping_risk_ratio_base) this.detail.shipping_risk_ratio_base = 'dd_order'
        if(this.detail.shipping_risk_ratio_percent == null)this.detail.shipping_risk_ratio_percent = 0

      }
    },
    save() {
      const param = Object.assign({}, this.form)
      if (!this.form.type) {
        this.$message.warning('请选择所属平台')
        return
      }
      if (this.form.type == 2 && this.form.alibaba_auto_purchase == null) {
        this.$message.warning('请选择是否自动采购')
        return
      }
      if (!this.form.phone) {
        this.$message.warning('手机号不能为空')
        return
      }
      if(param.type == 2){
        const feeEnable = Number(param.shipping_risk_fee_enable) === 1;
        const ratioEnable = Number(param.shipping_risk_ratio_enable) === 1;
        if(feeEnable){
          const feeAmount = Number(param.shipping_risk_fee_amount);
          if(param.shipping_risk_fee_amount === '' || param.shipping_risk_fee_amount === null || Number.isNaN(feeAmount) || feeAmount < 0){
            this.$message({message: '运费风控：请填写有效的代发费阈值N（≥0）',type: 'warning',});
            return;
          }
        }
        if(ratioEnable){
          const ratioPercent = Number(param.shipping_risk_ratio_percent);
          if(!param.shipping_risk_ratio_base){
            this.$message({message: '运费风控：请选择占比分母',type: 'warning',});
            return;
          }
          if(param.shipping_risk_ratio_percent === '' || param.shipping_risk_ratio_percent === null || Number.isNaN(ratioPercent) || ratioPercent <= 0){
            this.$message({message: '运费风控：请填写有效的占比阈值n（>0）',type: 'warning',});
            return;
          }
        }
      }
      this.saving = true
      const func = param.id > 0 ? this.opPddAccountUpdate : this.opPddAccountAdd
      func({
        data: param,
        success: (res) => {
          this.saving = false
          if (res.code === 200) {
            this.$message.success(res.msg)
            this.editShow = false
            this.getList(false)
          } else {
            this.$message.error(res.msg || res.message)
          }
        }
      })
    },
    del(row) {
      this.$confirm('删除后无法恢复，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.postDelete(row.id)
      }).catch(() => {})
    },
    batchDelete() {
      if (!this.selectedIds.length) return
      this.$confirm('删除后无法恢复，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.postDelete(this.selectedIds.join(','))
      }).catch(() => {})
    },
    postDelete(ids) {
      this.opPddAccountDel({
        data: { id: ids },
        success: (res) => {
          if (res.code === 200) {
            this.$message.success(res.msg)
          } else {
            this.$message.error(res.msg)
          }
          this.getList(false)
        }
      })
    },
    toAuth(item) {
      window.open(item.auth_url)
    },
    setDefault(item) {
      this.opPddAccountDefault({
        data: { id: item.id },
        success: (res) => {
          if (res.code === 200) {
            this.$message.success(res.msg)
          } else {
            this.$message.error(res.msg)
          }
          this.getList(false)
        }
      })
    },
    syncOrder(item) {
      this.opPddAccountSyncOrder({
        data: { id: item.id },
        success: (res) => {
          if (res.code === 200) {
            this.$message.success(res.msg)
          } else {
            this.$message.error(res.msg)
          }
          this.getList(false)
        }
      })
    },
    handlerOpenPay() {
      const html = `<div>
        <p style="font-weight: bold;font-size: 14px;">开启后，免密订单笔数无限制，采购更快捷</p>
        <p style="font-size: 12px;">1、请使用当前登录的1688账号绑定支付宝；</p>
        <p style="font-size: 12px;">2、且务必保证支付宝余额充足，余额不足将不能支付；</p>
        <p style="font-size: 12px;">3、单笔支付限额500元/笔;支付笔数不限。</p>
      </div>`
      this.$alert(html, '开通支付宝免密支付', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '去开通',
        cancelButtonText: '暂不开通',
        closeOnClickModal: true,
        closeOnPressEscape: true,
        showClose: false,
        showCancelButton: true
      }).then(() => {
        window.open('https://tradeconfig.1688.com/foundation/withhold_manage.htm')
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.gx-purch__head{
  margin-bottom: 14px;
}
.gx-purch__head-row {
  background: rgb(255, 255, 255);
  border-radius: 8px;
  border: 2px solid rgb(224, 224, 236);
  padding: 10px 14px;
  margin-bottom: 14px;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 4px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.gx-purch__head-opts{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}


/* 筛选标签 */
.gx-purch__filter-label {
  font-size: 12px;
  color: rgb(74, 74, 106);
  white-space: nowrap;
}
.gx-purch__tab {
  height: 28px;
  line-height: 28px;
  padding: 0px 14px;
  border-radius: 14px;
  cursor: pointer;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 12px;
  font-weight: 400;
  color: rgb(106, 106, 138);
  background: rgb(245, 245, 245);
  border: 1px solid rgb(224, 224, 236);
  transition: 0.15s;
  box-sizing: border-box;
}

.gx-purch__tab--on {
  font-weight: 600;
  color: rgb(82, 196, 26);
  background: rgb(245, 240, 232);
}
.gx-purch__tab--normal{
  font-weight: 600;
  color: rgb(82, 196, 26);
  background: rgb(246, 255, 237);
  border: 1px solid rgb(183, 235, 143);
}
.gx-purch__tab--invalid{
  font-weight: 600;
  color: rgb(200, 68, 60);
  background: rgb(255, 245, 245);
  border: 1px solid rgb(255, 204, 199);
}
.gx-purch__tab-check {
  font-weight: 500;
}
/* 按钮基础 */
.gx-purch__btn {
  height: 30px;
  padding: 0px 14px;
  border-radius: 6px;
  cursor: pointer;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 13px;
  font-weight: 600;
  border-image: none;
  background: rgb(255, 255, 255);
  border: 1px solid rgb(224, 224, 236);
  color: rgb(74, 74, 106);
  opacity: 1;
  transition: 0.15s;
  white-space: nowrap;
}

.gx-purch__btn--mini{
  font-size: 11px;
  padding: 0 9px;
  height: 26px;
}
.gx-purch__btn:disabled {
  opacity: .5;
  cursor: not-allowed;
}

.gx-purch__btn--query{
  background: linear-gradient(135deg, rgb(212, 169, 70), rgb(232, 199, 120));
  color: #ffffff;
}

.gx-purch__btn--add {
  background: linear-gradient(135deg, rgb(200, 68, 60), rgb(240, 117, 117));
  box-shadow: rgba(255, 77, 79, 0.25) 0px 0px 10px;
  color: #ffffff;
}

.gx-purch__btn--reset:hover{
  background: rgb(245,240,232);
}

.gx-purch__btn--del {
  background: rgba(248, 113, 113, 0.07);
  border: 1px solid rgb(255, 204, 199);
  color: rgb(248, 113, 113);
}
.gx-purch__btn--del:hover {
  background: rgba(248, 113, 113, 0.18);
}
.gx-purch__btn--del:disabled{
  opacity: 0.5;
  cursor: not-allowed;
}

.gx-purch__btn--red {
  background: #F0413E;
  border: none;
  color: #fff;
  font-weight: 600;
}
.gx-purch__btn--red:disabled {
  opacity: .5;
}

/* 搜索框 */
.gx-purch__table-page{
  background: rgb(255, 255, 255);
  border-radius: 8px;
  border: 2px solid rgb(224, 224, 236);
  box-shadow: rgba(0, 0, 0, 0.05) 0 1px 4px;
}
/* 表格 */
.gx-purch__table {
  border-radius: 8px 8px 0 0;
  overflow: hidden;
  background: #FFFFFF;
}
.gx-purch__table table {
  width: 100%;
  border-collapse: collapse;
}
.gx-purch__table th {
  padding: 10px 12px;
  text-align: left;
  background: rgb(245, 240, 232);
  font-size: 11px;
  font-weight: 500;
  color: rgb(74, 74, 106);
  border-bottom: 1px solid rgb(224, 224, 236);
  letter-spacing: 0.04em;
}
.gx-purch__table td {
  padding: 12px 13px;
  font-size: 12px;
  color:#4a4a6a;
  border-bottom: 1px solid #F0F0F0;
  vertical-align: middle;
}
.gx-purch__table tbody tr:hover {
  background: #FAFBFF;
}
/* 复选框 */
.gx-purch__checkall,
.gx-purch__check {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-size: 12px;
  color: #666;
}
.gx-purch__checkall input,
.gx-purch__check input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}
.gx-purch__checkall-box,
.gx-purch__check-box {
  width: 14px;
  height: 14px;
  border-radius: 3px;
  border: 1.5px solid rgb(224, 224, 236);
  background: #FFFFFF;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all .15s;
}
.gx-purch__checkall input:checked + .gx-purch__checkall-box,
.gx-purch__check input:checked + .gx-purch__check-box {
  background: rgb(200, 68, 60);
  border: 1.5px solid rgb(200, 68, 60);
}
/* 平台标签 */
.gx-purch__plat {
  padding: 3px 10px;
  border-radius: 5px;
  font-size: 11px;
  font-weight: 600;

}
.gx-purch__plat--pdd {
  background: rgb(255, 245, 245);
  border: 1px solid rgb(255, 204, 199);
  color: rgb(200, 68, 60);
}
.gx-purch__plat--tb {
  background: rgb(255, 247, 230);
  border: 1px solid rgb(255, 213, 145);
  color:rgb(251, 146, 60);;
}
/* 采购账号链接 */
.gx-purch__account-link {
  color: rgb(22, 119, 255);
  font-size: 12px;
  cursor: pointer;
}
.gx-purch__account-link:hover {
  text-decoration: underline;
}
/* 利润差 */
.gx-purch__profit {
  display: flex;
  align-items: center;
  gap: 5px;
}
.gx-purch__profit-num {
  font-size: 13px;
  font-weight: 700;
  color: rgb(200, 68, 60) !important;
}
.gx-purch__profit-tip {
  font-size: 10px;
  color: rgb(106, 106, 138)!important;
}
/* 默认标签 */
.gx-purch__tag {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 3px;
  font-size: 11px;
  line-height: 18px;
}
.gx-purch__default {
  padding: 1px 7px;
  border-radius: 10px;
  background: rgb(225, 229, 238);
  border: 1px solid rgba(212, 169, 70, 0.4);
  font-family: "Noto Sans SC", sans-serif;
  font-size: 10px;
  font-weight: 600;
  color: rgb(212, 169, 70);
}
/* 名称包裹 */
.gx-purch__name-wrap {
  display: flex;
  align-items: center;
  gap: 6px;
}
.gx-purch__name-text {
  font-size: 13px;
  color: rgb(26, 26, 46);
  font-weight: 500;
}
/* 授权信息 */
.gx-purch__auth {
  font-size: 12px;
  line-height: 1.6;
}
.gx-purch__auth-line {
  font-size: 11px;
  color: rgb(106, 106, 138);
  margin: 3px 0;
}
.gx-purch__auth-line-con {
  color: rgb(26, 26, 46);
}
.gx-purch__auth-bar {
  height: 8px;
  border-radius: 4px;
  background: #F0F0F0;
  margin: 6px 0;
  overflow: hidden;
}
.gx-purch__auth-bar-fill {
  height: 100%;
  width: 100%;
  border-radius: 4px;
  background: linear-gradient(90deg, #22C55E, #4ADE80);
}
.gx-purch__auth-pay {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 4px;
  background: rgb(246, 255, 237);
  border: 1px solid rgb(183, 235, 143);
  color: rgb(82, 196, 26);
}
.gx-purch__auth-pay-dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: rgb(82, 196, 26);
}
.gx-purch__auth-pay--err{
  background: rgb(255, 245, 245);
  border: 1px solid rgb(255, 204, 199);
  color: rgb(200, 68, 60);
}
.gx-purch__auth-pay--err .gx-purch__auth-pay-dot{
  background: rgb(200, 68, 60);
}
/* 授权状态标签（带圆点） */
.gx-purch__stat {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 10px;
  border-radius: 10px;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 11px;
  font-weight: 600;
}
.gx-purch__stat-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
}
.gx-purch__stat--ok {
  background: rgb(246, 255, 237);
  border: 1px solid rgb(183, 235, 143);
  color: rgb(82, 196, 26);
}
.gx-purch__stat--ok .gx-purch__stat-dot {
  background:rgb(82, 196, 26);
}
.gx-purch__stat--err {
  background: rgb(255, 245, 245);
  border: 1px solid rgb(255, 204, 199);
  color: rgb(200, 68, 60);
}
.gx-purch__stat--err .gx-purch__stat-dot {
  background: rgb(200, 68, 60);
}
/* 操作按钮包裹 */
.gx-purch__ops {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
}
/* 标签化操作按钮 */
.gx-purch__op-btn {
  height: 24px;
  padding: 0 8px;
  border-radius: 4px;
  cursor: pointer;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 11px;
  white-space: nowrap;
}
.gx-purch__op-btn--red {
  background: rgb(255, 245, 245);
  border: 1px solid rgb(255, 204, 199);
  color: rgb(200, 68, 60);
}
.gx-purch__op-btn--red:hover {
  background: rgb(200, 68, 60);
  color: #ffffff;
}
.gx-purch__op-btn--blue {
  background: rgb(230, 244, 255);
  border: 1px solid rgb(145, 202, 255);
  color:#1677ff;
}
.gx-purch__op-btn--blue:hover {
  background: rgb(22,119,255);
  color: #ffffff;
}
.gx-purch__op-btn--gray {
  background: rgb(245, 245, 245);
  border: 2px solid rgb(224, 224, 236);
  color: rgb(74, 74, 106);
}
.gx-purch__op-btn--gray:hover {
  background: rgb(232,232,232);
}
.gx-purch__op-btn--orange {
  background: rgba(212, 169, 70, 0.1);
  border: 1px solid rgba(212, 169, 70, 0.3);
  color: rgb(212, 169, 70);;
}
.gx-purch__op-btn--orange:hover {
  background: rgb(212,169,70);
  color: #ffffff;
}

.gx-purch__empty {
  text-align: center;
  padding: 52px 0 !important;
  color: #999;
  font-size: 13px;
}
/* 分页 */
.gx-purch__pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  border-top: 1px solid rgb(224, 224, 236);
  background: rgb(245, 240, 232);
  border-radius: 0 0 8px 8px;
}
.gx-purch__pager-left {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.gx-purch__pager-total {
  font-size: 12px;
  color: #666;
}
.gx-purch__pager-btns {
  display: flex;
  gap: 6px;
  align-items: center;
}
.gx-purch__page {
  min-width: 28px;
  height: 26px;
  padding: 0 8px;
  border-radius: 4px;
  border: 1px solid #E1E5EE;
  background: #FFFFFF;
  cursor: pointer;
  font-size: 13px;
  color: #4A4A6A;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all .15s;
}
.gx-purch__page:hover:not(:disabled):not(.gx-purch__page--on) {
  border-color: #1966FF;
  color: #1966FF;
}
.gx-purch__page:disabled {
  opacity: .4;
  cursor: not-allowed;
}
.gx-purch__page--on {
  border: 1px solid rgb(200, 68, 60);
  background: rgb(255, 245, 245);
  color: rgb(200, 68, 60);
}

.gx-modal-box{
  width: 100%;
  max-width: 600px;
  border: 2px solid rgb(224, 224, 236);
  border-radius: 10px;
  background: #FFFFFF;
  box-shadow: 0 12px 48px rgba(0, 0, 0, .18);
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  overflow: hidden;
}

.gx-modal {
  background: rgba(0, 0, 0, .42);
  backdrop-filter: blur(4px);
}

.gx-modal-head {
  flex-shrink: 0;
  padding: 13px 18px;
  background: rgb(245, 240, 232);
}
.gx-modal-title-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
}
.gx-modal-title {
  padding-left: 11px;
  font-size: 15px;
}
.gx-modal-title::before {
  width: 3px;
  height: 15px;
  border-radius: 2px;
  background: rgb(200, 68, 60);
}
.gx-modal-close {
  width: 26px;
  height: 26px;
  padding: 0;
  border: 2px solid rgb(224, 224, 236);
  border-radius: 5px;
  color: #4A4A6A;
  background: #FFFFFF;
}
.gx-modal-close:hover {
  color: rgb(200, 68, 60);
  background: #FFF5F5;
}

.gx-modal-body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 18px;
}

.gx-purch__field {
  margin-bottom: 0;
}

.gx-purch__label {
  display: flex;
  align-items: baseline;
  gap: 5px;
  margin-bottom: 9px;
  font-size: 11px;
  letter-spacing: .06em;
  color: #4A4A6A;
  text-transform: uppercase;
}
.gx-purch__req {
  color: rgb(200, 68, 60);
  font-size: 13px;
  letter-spacing: 0;
}
.gx-purch__label-hint {
  color: #6A6A8A;
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0;
  text-transform: none;
}
.gx-purch__field :deep(.el-input--small .el-input__inner){
  min-height: 34px;
  line-height: 34px;
  border:2px solid #e0e0ec;
}
.gx-purch__field :deep(.el-input-number__decrease),
.gx-purch__field :deep(.el-input-number__increase){
  height: calc(100% - 4px);
}
.gx-purch__field :deep(el-input-number .el-input__inner){
  font-weight: 600;
  color: rgb(200, 68, 60);
}

.gx-purch__input {
  width: 100%;
  height: 36px;
  padding: 0 12px;
  border: 2px solid rgb(224, 224, 236);
  border-radius: 5px;
  outline: none;
  box-sizing: border-box;
  background: #FFFFFF;
  font-size: 13px;
  color: #1A1A2E;
  transition: border-color .15s, box-shadow .15s;
}

.gx-purch__input--sm {
  width: 120px;
}
.gx-purch__delay-row {
  display: flex;
  align-items: center;
  gap: 10px;
}
.gx-purch__unit {
  font-size: 14px;
  color: #666;
}
.gx-purch__field-tip {
  font-size: 12px;
  color: rgb(106, 106, 138);
}
.gx-purch__field-tip span{
  color: rgb(200, 68, 60);
  font-weight: 600;
}
.gx-purch__field-tip--tag{
  font-family: "Noto Sans SC", sans-serif;
  font-size: 11px;
  color: rgb(106, 106, 138);
  padding: 4px 9px;
  border-radius: 4px;
  background: rgb(245, 245, 245);
  border: 2px solid rgb(224, 224, 236);
}
.gx-purch__field-note {
  margin: 4px 0 0;
  font-size: 10px;
  line-height: 1.4;
  color: #6A6A8A;
}
.gx-purch__radio-row {
  display: flex;
  gap: 8px;
}
.gx-purch__radio {
  flex: 1;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  padding: 8px 16px;
  border: 2px solid rgb(224, 224, 236);
  border-radius: 7px;
  background: rgb(245, 240, 232);
  cursor: pointer;
  font-size: 13px;
  color: #1A1A2E;
  transition: .18s;
}
.gx-purch__radio input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}
.gx-purch__radio-dot {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 2px solid rgb(224, 224, 236);
  background: transparent;
  position: relative;
  flex-shrink: 0;
  transition: all .15s;
}
.gx-purch__radio-dot::after {
  content: '';
  position: absolute;
  inset: 2px;
  border-radius: 50%;
  background: rgb(200, 68, 60);
  transform: scale(0);
  transition: transform .15s;
}
.gx-purch__radio--on .gx-purch__radio-dot {
  border-color: rgb(200, 68, 60);
}
.gx-purch__radio--on .gx-purch__radio-dot::after {
  transform: scale(1);
}
.gx-purch__radio--on {
  border-color: rgb(200, 68, 60);
  background: rgb(255, 245, 245);
  color: rgb(200, 68, 60);
  font-weight: 500;
}

/*运费风控*/
.shipping-risk-row{
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin-bottom:8px;
  font-size: 13px;
  color:#1a1a2e;
}
.gx-modal-body >>> .gx-ms {
  display: block;
  width: 100%;
}
.gx-modal-body >>> .gx-ms__btn {
  width: 100%;
  min-width: 0;
  height: 34px;
  padding: 0 10px;
  border-radius: 5px;
  font-size: 13px;
}
.gx-modal-foot {
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
  gap: 8px;
  margin: 0 18px;
  padding: 14px 0 16px;
  border-top: 1px solid #E1E5EE;
}
</style>
